import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import RoleBadge from '../../RoleBadge';

const API_URL = 'https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/deliverable';

const UserTable = ({
  users,
  onAdvance,
  onToggleStatus,
  onDelete,
  onOpenDeliverables,
  deliverableStatuses = {},
  setDeliverableStatuses
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    users.forEach((user) => {
      const { confirmed, passed } = deliverableStatuses[user.id] || {};
      if (user.progress && confirmed && passed) {
        onAdvance(user);
        setDeliverableStatuses(prev => ({
          ...prev,
          [user.id]: { confirmed: false, passed: false }
        }));
      }
    });
  }, [users, deliverableStatuses, onAdvance, setDeliverableStatuses]);

  const handleMarkPassed = async (user) => {
    if (!user?.progress) return;
    const { curriculum_name, session_number } = user.progress;

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'updateTestPassed',
          userId: user.id,
          curriculumName: curriculum_name,
          sessionNumber: session_number
        })
      });

      if (!res.ok) throw new Error('合格フラグ更新に失敗しました');

      setDeliverableStatuses(prev => ({
        ...prev,
        [user.id]: {
          ...(prev[user.id] || {}),
          passed: true
        }
      }));
    } catch (err) {
      alert(err.message);
      console.error(err);
    }
  };

  return (
    <table>
      <thead>
        <tr>
          <th>利用者名</th>
          <th>ロール</th>
          <th>トークン</th>
          <th>状態</th>
          <th>進行度</th>
          <th>合格確認</th>
          <th>成果物確認</th>
          <th>一時停止 / 再開</th>
          <th>削除</th>
          <th>在宅記録</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => {
          const { confirmed, passed } = deliverableStatuses[user.id] || {};
          const isDisabled = user.role >= 5 || !user.progress?.next_session_exists || (confirmed && passed);
          const rowClass = user.dailyFlaggedRed ? 'red-row' : '';

          return (
            <tr key={user.id} className={rowClass}>
              <td>{user.name}</td>
              <td><RoleBadge role={user.role} /></td>
              <td>
                <div className='user-token'>
                  {user.login_code}
                  <button className="copy-button" onClick={() => {
                    navigator.clipboard.writeText(user.login_code);
                    alert('コピーしました');
                  }}>コピー</button>
                </div>
              </td>
              <td>{user.status === 1 ? '稼働中' : '停止中'}</td>
              <td>
                {user.progress ? (
                  <div>
                    {user.progress.curriculum_name}
                    <br />
                    第{user.progress.session_number}回
                  </div>
                ) : '未進行'}
              </td>
              <td>
                {user.progress ? (
                  <button
                    className={passed ? "passed-button" : "secondary-button"}
                    onClick={() => handleMarkPassed(user)}
                    disabled={isDisabled}
                  >
                    {passed ? '合格済' : '合格'}
                  </button>
                ) : '未進行'}
              </td>
              <td>
                <button
                  onClick={() => onOpenDeliverables(user)}
                  disabled={confirmed && passed}
                >
                  {confirmed ? '確認済' : '未確認'}
                </button>
              </td>
              <td>
                <button onClick={() => onToggleStatus(user.id, user.status)} disabled={user.role >= 5}>
                  {user.status === 1 ? '停止' : '再開'}
                </button>
              </td>
              <td>
                <button className="danger-button" onClick={() => onDelete(user.id)} disabled={user.role >= 5}>削除</button>
              </td>
              <td>
                <button
                  disabled={!user.hasDailyRecord}
                  title={!user.hasDailyRecord ? '通所のみ' : ''}
                  onClick={() =>
                    navigate(`/daily-record/${user.login_code}`, {
                      state: { userName: user.name }
                    })
                  }
                >
                  記録をつける
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default UserTable;
